module.exports = __webpack_public_path__ + "@/assets/img/gold.45dec566.jpeg";